export default __webpack_public_path__ + "static/media/Quarterfilledcircle.09aec79c.svg";